import React from 'react';
import { LayoutDashboardIcon, MapPinIcon, BellIcon, MapIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
interface BottomNavProps {
  currentPage: string;
  navigateTo: (page: string) => void;
}
export function BottomNav({
  currentPage,
  navigateTo
}: BottomNavProps) {
  const {
    t
  } = useLanguage();
  const navItems = [{
    id: 'dashboard',
    icon: LayoutDashboardIcon,
    label: t('navDashboard')
  }, {
    id: 'myPlots',
    icon: MapPinIcon,
    label: t('navMyPlots')
  }, {
    id: 'notifications',
    icon: BellIcon,
    label: t('navNotifications')
  }, {
    id: 'map',
    icon: MapIcon,
    label: t('navMap')
  }];
  return <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 flex justify-around items-center h-16 pb-safe z-20 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)]" data-id="element-29">
      {navItems.map(item => {
      const Icon = item.icon;
      const isActive = currentPage === item.id || currentPage.startsWith(item.id) && item.id !== 'dashboard';
      return <button key={item.id} onClick={() => navigateTo(item.id)} className={`flex flex-col items-center justify-center w-full h-full space-y-1 ${isActive ? 'text-[#006A4E]' : 'text-gray-500 hover:text-gray-900'}`} data-id="element-30">
            <Icon className={`w-6 h-6 ${isActive ? 'fill-[#006A4E]/10' : ''}`} data-id="element-31" />
            <span className="text-[10px] font-medium" data-id="element-32">{item.label}</span>
          </button>;
    })}
    </nav>;
}